export default "__VITE_ASSET__Ccqhk$Xz__"